<template>
    <div class="home-page page-container">
        <div></div>
        <div class="center-wrap">
            <div class="icons">
                <img src="@/assets/logo.png" class="logo"/>
                <img src="@/assets/betaicon.png" class="betaicon"/>
            </div>
            <Search
                :searching="false"
            />
            <div class="from-tip">
                <img src="@/assets/light.png"/>
                <p>搜索结果来自于果壳及其他科普公众号</p>
            </div>
        </div>
        <p class="footer">
            <span class="link feedback" @click="feedback">意见反馈</span>
            <span class="link guokr-only" @click="handleOnlyGuokr">只搜果壳</span>
        </p>
    </div>
</template>

<script>
// components
import Search from '@/components/Search'
// mixins
import feedbackMixin from '@/mixins/feedback'

import { sendEvent } from '@/methods/ga'

export default {
    components: {
        Search
    },
    mixins: [feedbackMixin],
    methods: {
        handleOnlyGuokr () {
            sendEvent('home:click:newrank_search')
            // 跳转至号内搜
            window.location = 'https://data.newrank.cn/m/s.html?s=NyotPD42'
        }
    }
}
</script>

<style lang="less" scoped>
.home-page {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .center-wrap {
        padding: 0 30px;
        margin-top: -130px;
        .icons {
            position: relative;
            .logo {
                width: 130px;
                margin-bottom: 30px;
            }
            .betaicon {
                position: absolute;
                width: 31px;
                top: 0;
                padding-left: 5px;
            }
        }
        .from-tip {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 23px;
            img {
                width: 14px;
            }
            p {
                color: rgba(12, 136, 186, 0.6);
                font-size: 14px;
                margin-left: 6px;
            }
        }
    }
    .footer {
        font-size: 14px;
        line-height: 20px;
        color: #B1B1B1;
        margin-bottom: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .link {
            color: rgba(12, 136, 186, 0.6);
            font-size: 13px;
            text-decoration: underline;
            margin-bottom: 6px;
            margin: 0 12.5px;
            cursor: pointer;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue